import { XYChart } from '@amcharts/amcharts4/charts';
import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { ChangeDetectionStrategy, Component, ElementRef, Input, NgZone, OnDestroy, QueryList, ViewChildren } from '@angular/core';
import { CanDestroyNotify, mixinDestroyNotifier } from '@mtna/core-angular';
import { RegressionDataSet } from '@rds/rds-base-ts';
import { skipWhile, take } from 'rxjs/operators';

const RdsRegressionChartBase = mixinDestroyNotifier(class {});

@Component({
  selector: 'rds-c-regression-chart',
  templateUrl: 'regression-chart.component.html',
  styleUrls: ['regression-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RdsRegressionChartComponent extends RdsRegressionChartBase implements CanDestroyNotify, OnDestroy {
  static ngAcceptInputType_loadingChart: BooleanInput;

  @ViewChildren('regressionChart') chartElements: QueryList<ElementRef> | undefined;

  @Input()
  get loadingChart(): boolean {
    return this._loadingChart;
  }
  set loadingChart(l: boolean) {
    this._loadingChart = coerceBooleanProperty(l);
  }
  private _loadingChart = false;

  @Input()
  get chartData(): RegressionDataSet | null | undefined {
    return this._chartData;
  }
  set chartData(data: RegressionDataSet | null | undefined) {
    this._chartData = data;
    if (this.chartData) {
      this._cleanupChart(this._chart);
      this._checkAndCreateChart();
    } else {
      this._cleanupChart(this._chart);
    }
  }
  private _chartData: RegressionDataSet | null | undefined;

  protected _chart: XYChart | undefined;

  constructor(protected zone: NgZone) {
    super();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this._cleanupChart(this._chart);
  }

  /** Queries the ViewChildren until it finds the element, then triggers chart generation. */
  protected _checkAndCreateChart(attempts = 0) {
    setTimeout(() => {
      if (this.chartElements?.length) {
        this._generateRegressionChart();
      } else if (this.chartElements) {
        this.chartElements.changes
          .pipe(
            skipWhile((list) => list.length !== 1),
            take(1)
          )
          .subscribe(() => this._generateRegressionChart());
      } else if (attempts < 4) {
        setTimeout(() => this._checkAndCreateChart(), attempts + 1);
      } else {
        console.error('[RdsRegressionChartComponent] Failed to build regression chart');
      }
    }, 1);
  }

  /** Disposes of a chart */
  protected _cleanupChart(chart: XYChart | undefined) {
    this.zone.runOutsideAngular(() => {
      if (chart) {
        chart.dispose();
      }
    });
  }

  /** Generates the regression chart with the given data. */
  protected _generateRegressionChart() {
    // this.zone.runOutsideAngular(async () => {
    //   this._chart = await createLinearChart(this._chartData, this.chartElements?.first.nativeElement);
    // });
  }
}
